import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Laporan() {
  const [garduList, setGarduList] = useState([]);
  const [selectedGI, setSelectedGI] = useState('');
  const [bulan, setBulan] = useState(new Date().getMonth() + 1);
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [isLoading, setIsLoading] = useState(false);
  const [psriData, setPsriData] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const bulanList = [
    'Januari','Februari','Maret','April','Mei','Juni',
    'Juli','Agustus','September','Oktober','November','Desember'
  ];

  useEffect(() => { loadGarduList(); }, []);

  const loadGarduList = async () => {
    try {
      const res = await api.get('/gardu');
      setGarduList(res.data.data || []);
      if (res.data.data?.length > 0) setSelectedGI(res.data.data[0].id);
    } catch (err) { console.error(err); }
  };

  const loadPreview = async () => {
    if (!selectedGI) return;
    setIsLoading(true);
    try {
      const res = await api.get(`/dashboard/gi/${selectedGI}`);
      setPsriData(res.data.data?.psri_bulan_ini || res.data.data);
    } catch (err) { console.error(err); }
    setIsLoading(false);
  };

  const downloadApdPDF = async () => {
    if (!selectedGI) return;
    setIsDownloading(true);
    try {
      const res = await api.get(`/laporan/apd/${selectedGI}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const namaGI = garduList.find(g => g.id == selectedGI)?.nama || 'GI';
      link.setAttribute('download', `Laporan_APD_${namaGI}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert('Gagal download PDF APD.');
    }
    setIsDownloading(false);
  };

  const downloadPDF = async () => {
    setIsDownloading(true);
    try {
      const res = await api.get(`/laporan/psri/${bulan}/${tahun}`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const namaGI = garduList.find(g => g.id == selectedGI)?.nama || 'ULTG';
      link.setAttribute('download', `Laporan_PSRI_${bulanList[bulan-1]}_${tahun}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert('Gagal download PDF. Pastikan data inspeksi sudah ada untuk periode ini.');
    }
    setIsDownloading(false);
  };

  const getStatusColor = (nilai) => {
    const n = parseFloat(nilai || 0);
    if (n >= 80) return 'text-green-600';
    if (n >= 60) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getStatusLabel = (nilai) => {
    const n = parseFloat(nilai || 0);
    if (n >= 80) return '✅ SIAP';
    if (n >= 60) return '⚠️ SIAP SEBAGIAN';
    return '🔴 TIDAK SIAP';
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Laporan PDF</h1>

      {/* Form laporan */}
      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 mb-6">
        <h2 className="font-bold text-gray-800 mb-4">Generate Laporan Rekap PSRI</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Gardu Induk (Preview)</label>
            <select value={selectedGI} onChange={(e) => setSelectedGI(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
              {garduList.map(gi => <option key={gi.id} value={gi.id}>{gi.nama}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Bulan</label>
            <select value={bulan} onChange={(e) => setBulan(parseInt(e.target.value))}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
              {bulanList.map((b, i) => <option key={i+1} value={i+1}>{b}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Tahun</label>
            <select value={tahun} onChange={(e) => setTahun(parseInt(e.target.value))}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
              {[2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
        </div>
        <div className="flex gap-3">
          <button onClick={loadPreview} disabled={isLoading}
            className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium disabled:opacity-50">
            {isLoading ? '⏳ Memuat...' : '👁️ Preview GI'}
          </button>
          <button onClick={downloadPDF} disabled={isDownloading}
            className="px-6 py-2 bg-green-700 text-white rounded-lg hover:bg-green-600 transition-colors font-medium disabled:opacity-50">
            {isDownloading ? '⏳ Downloading...' : '📥 Download Laporan Rekap PDF'}
          </button>
          <button onClick={downloadApdPDF} disabled={isDownloading}
            className="px-6 py-2 bg-blue-700 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium disabled:opacity-50">
            {isDownloading ? '⏳...' : '📋 Download PDF APD per GI'}
          </button>
        </div>
        <p className="text-xs text-gray-400 mt-2">* Laporan PDF berisi rekap PSRI semua GI untuk bulan yang dipilih</p>
      </div>

      {/* Preview */}
      {isLoading ? (
        <div className="flex justify-center p-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
        </div>
      ) : psriData && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="p-6 border-b border-gray-100 bg-green-700 rounded-t-xl">
            <h2 className="text-white font-bold text-lg">Preview - {garduList.find(g => g.id == selectedGI)?.nama}</h2>
            <p className="text-green-200 text-sm">{bulanList[bulan-1]} {tahun}</p>
          </div>
          <div className="p-6">
            <div className="text-center mb-8">
              <p className="text-gray-500 mb-2">Nilai PSRI</p>
              <p className={`text-6xl font-bold ${getStatusColor(psriData.nilai_psri)}`}>
                {parseFloat(psriData.nilai_psri || 0).toFixed(1)}
              </p>
              <p className={`text-xl font-bold mt-2 ${getStatusColor(psriData.nilai_psri)}`}>
                {getStatusLabel(psriData.nilai_psri)}
              </p>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center p-4 bg-red-50 rounded-xl">
                <p className="text-gray-500 text-sm">APAR (40%)</p>
                <p className={`text-3xl font-bold mt-1 ${getStatusColor(psriData.nilai_apar)}`}>
                  {parseFloat(psriData.nilai_apar || 0).toFixed(1)}
                </p>
              </div>
              <div className="text-center p-4 bg-blue-50 rounded-xl">
                <p className="text-gray-500 text-sm">APD (35%)</p>
                <p className={`text-3xl font-bold mt-1 ${getStatusColor(psriData.nilai_apd)}`}>
                  {parseFloat(psriData.nilai_apd || 0).toFixed(1)}
                </p>
              </div>
              <div className="text-center p-4 bg-green-50 rounded-xl">
                <p className="text-gray-500 text-sm">P3K (25%)</p>
                <p className={`text-3xl font-bold mt-1 ${getStatusColor(psriData.nilai_p3k)}`}>
                  {parseFloat(psriData.nilai_p3k || 0).toFixed(1)}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
